// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"2ed65066","264":"61da5a27","314":"cf76484c","691":"b7a53f23","773":"0c13c5ae","867":"b8c53be3"}[chunkId] + ".chunk.css";
};